const initialState = {
  projectId: null,
  source: null,
  document: {
    id: null,
    isActive: false,
    origin: null,
  },
  list: {
    list: [],
    totalCount: 0,
  },
  onAddComment: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'COMMENTS_SET_PROJECT_ID':
      return {
        ...state,
        projectId: action.projectId,
      };

    case 'COMMENTS_SET_DOCUMENT':
      return {
        ...state,
        document: action.document,
      };
    case 'COMMENTS_SET_SOURCE':
      return {
        ...state,
        source: action.source,
      };

    case 'COMMENTS_SET_ON_ADD_COMMENT':
      return {
        ...state,
        onAddComment: action.onAddComment,
      };

    case 'COMMENTS_UPDATE_LIST':
      return {
        ...state,
        list: {
          ...state.list,
          list: action.list,
        },
      };

    case 'COMMENTS_UPDATE_LIST_COUNT':
      return {
        ...state,
        list: {
          ...state.list,
          totalCount: action.totalCount,
        },
      };

    case 'FILEUPLOAD_RESET':
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
